import * as yup from 'yup';

import { bookingFormFieldType } from 'constants/appointments';

const defaultRequiredMessage = 'This field is required';

const getValidationSchema = (fields, showDateTimePicker, requireDateTime, user) => {
  const customFieldsSchema = fields.reduce((acc, { name, isRequired, fieldType }) => {
    let fieldValidation;

    if (fieldType === bookingFormFieldType.checkbox) {
      fieldValidation = yup.array().of(yup.string());

      if (isRequired) {
        fieldValidation = fieldValidation
          .test(
            name,
            defaultRequiredMessage,
            ((array) => array.some((x) => Boolean(x) && x !== 'false')),
          );
      }

      return {
        ...acc,
        [name]: fieldValidation,
      };
    }

    if (fieldType === bookingFormFieldType.image) {
      fieldValidation = yup.string();
    } else {
      fieldValidation = yup.string().max(255, 'Value is too long - should be 255 chars maximum');
    }

    if (fieldType === bookingFormFieldType.textArea) {
      fieldValidation.min(2, 'Value is too short - should be two chars minimum');
    }

    if (isRequired) {
      fieldValidation = fieldValidation.required(defaultRequiredMessage);
    }

    return {
      ...acc,
      [name]: fieldValidation,
    };
  }, {});

  const validationSchema = yup.object().shape({
    isAddressInArea: yup.boolean().required(),
    geoData: yup.object().shape({
      latitude: yup.number().required(),
      longitude: yup.number().required(),
    }),
    address: yup.string()
      .min(2, 'Property must be at least 2 characters')
      .max(255, 'Property must be at most 255 characters')
      .required('Property is a required field')
      .when('geoData', {
        is: (geoData) => !geoData.latitude || !geoData.longitude,
        then: (schema) => schema.test(
          'Invalid value',
          'Invalid value of the specified property',
          () => false,
        ),
      })
      .when('isAddressInArea', {
        is: (isAddressInArea) => { return !isAddressInArea; },
        then: (sch) => sch.test(
          'Invalid value',
          'Unfortunately, we don’t provide our service at the specified property',
          () => false,
        ),
      }),
    unitNumber: yup.string().max(10, 'Unit/Suite/Apt. Number should be 10 characters maximum'),
    ...(!user.email ? { email: yup.string().email('Invalid email format').required('Email is required') } : {}),
    ...customFieldsSchema,
  });

  if (showDateTimePicker) {
    const dateSchema = requireDateTime
      ? yup.date().required('Date is a required field')
      : yup.date().nullable();

    const timeSchema = requireDateTime
      ? yup.string().required('Time is a required field')
      : yup.string().nullable();

    return validationSchema.shape({
      date: dateSchema,
      time: timeSchema,
    });
  }

  return validationSchema;
};

export default getValidationSchema;
